module.exports = __webpack_public_path__ + "img/U1F525.c33ad47e.png";